const ACCESS_TOKEN_KEY = "access_token";
const USER_INFO_KEY = "user_info";

export const getAccessToken = () => sessionStorage.getItem(ACCESS_TOKEN_KEY) || "";

export const setAccessToken = (token) => {
  if (!token) return;
  sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
};

export const clearAccessToken = () => {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
};

export const getUserInfo = () => {
  const userInfo = sessionStorage.getItem(USER_INFO_KEY);
  if (!userInfo) return {};

  try {
    return JSON.parse(userInfo);
  } catch {
    return {};
  }
};

export const setUserInfoStorage = (userInfo) => {
  if (!userInfo) return;
  sessionStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
};

export const clearUserInfoStorage = () => {
  sessionStorage.removeItem(USER_INFO_KEY);
};

export const clearAuthStorage = () => {
  clearAccessToken();
  clearUserInfoStorage();
};
